window.global = window;